import React, {FC} from 'react';
import {useTranslation} from '@aboutyou/i18n';
import styled from 'styled-components';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {COLORS} from '../../../constants/colors';

const Container = styled.div`
  padding: 15px;
  margin: 0;
`;

const Header = styled.h4`
  color: ${COLORS.Black};
  font-size: ${FONT_SIZES.px16};
  font-weight: ${FONT_WEIGHTS.light};
  padding-bottom: 10px;
  border-bottom: 1px solid ${COLORS.Black};
  margin: 0 0 10px;
`;

const Content = styled.span`
  color: ${COLORS.Black};
  font-size: ${FONT_SIZES.px14};
`;

interface Props {
  content?: string;
}

export const TermsAndConditions: FC<Props> = props => {
  const {t} = useTranslation();
  const {content} = props;

  const onContainerClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <Container onClick={onContainerClick} data-testid="termsAndConditions">
      <Header>{t('Promotion Terms & Conditions')}</Header>
      <Content>{content}</Content>
    </Container>
  );
};
